module.exports = __webpack_public_path__ + "static/media/blog3.325f7651.png";